import { Compass, Hammer, Droplets, Sparkles } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
const steps = [{
  stepNumber: "01",
  title: "Planering & materialval",
  description: "Vi går igenom badrummets förutsättningar, funktion, stil och material för att skapa en genomtänkt lösning.",
  icon: Compass
}, {
  stepNumber: "02",
  title: "Rivning & förberedelser",
  description: "Det befintliga badrummet rivs och underlaget förbereds för kommande installationer och ytskikt.",
  icon: Hammer
}, {
  stepNumber: "03",
  title: "VVS & badrumsinstallationer",
  description: "Rördragning, avlopp, golvvärme och installationer planeras utifrån badrummets nya utformning.",
  icon: Droplets
}, {
  stepNumber: "04",
  title: "Tätskikt, kakel & färdigställande",
  description: "Tätskikt, plattsättning och montering av inredning, dusch, badkar och blandare färdigställer badrummet.",
  icon: Sparkles
}];
export default function Process() {
  return <section id="renovationprocess" data-nav="light" className="bg-background text-foreground py-24 lg:py-32 font-default">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16 lg:mb-20">
          <h2 className="text-4xl md:text-5xl font-default font-semibold tracking-tight text-foreground mb-6">
            Renovera badrum i Värmland, från idé till färdigt badrum
          </h2>
          <p className="text-base md:text-lg text-muted-foreground leading-relaxed">
            Vi hjälper dig genom hela badrumsrenoveringen, från de första idéerna och materialvalen till installation och färdigställande. Varje badrum planeras efter bostadens förutsättningar, dina önskemål och den funktion du behöver.
          </p>
        </div>

        {/* Process Cards Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {steps.map((item, i) => {
          const Icon = item.icon;
          return <div key={item.stepNumber} data-index={i} className="h-full">
                <Card className="h-full border border-border bg-card rounded-lg p-8 transition-[border-color,box-shadow] duration-200 hover:shadow-md hover:border-primary/30 flex flex-col justify-between">
                  <CardContent className="p-0 flex flex-col h-full">
                    <div className="flex items-center justify-between mb-8">
                      <span className="text-xs font-semibold tracking-wider text-muted-foreground uppercase">
                        Steg {item.stepNumber}
                      </span>
                      <div className="size-10 rounded-md bg-accent flex items-center justify-center text-primary">
                        <Icon className="size-5 text-primary" />
                      </div>
                    </div>

                    <div className="space-y-3 mt-auto">
                      <h3 className="text-xl font-semibold text-foreground tracking-tight">
                        {item.title}
                      </h3>
                      <p className="text-sm text-muted-foreground leading-relaxed">
                        {item.description}
                      </p>
                    </div>
                  </CardContent>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}